const UpdateTableModalTestIdsScope = {
  UPDATE_TABLE_MODAL: 'update-table-modal',
};

export const UpdateTableModalTestIds = {
  getRecordActionButtonId: id =>
    `${UpdateTableModalTestIdsScope.UPDATE_TABLE_MODAL}.record-action-button-${id}`,
  getRecordErrorIndicatorId: id =>
    `${UpdateTableModalTestIdsScope.UPDATE_TABLE_MODAL}.record-error-indicator-${id}`,
};
